import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import { PlayerQuickAction } from "./dtos";

const QUICK_ACTION_SERVICE = `${Constants.API_URL}/bedrock/quick_actions`;

export class PlayerDashboardServices {
  @scCatchServiceException()
  static async getQuickActions(): Promise<PlayerQuickAction[]> {
    const { data } = await axios.get<PlayerQuickAction[]>(QUICK_ACTION_SERVICE);
    return data;
  }
}
